/**
 * Mock Data Service for Development
 * This service provides realistic mock data for testing and development.
 * Can be easily disabled for production by setting USE_MOCK_DATA to false.
 */

import { config } from '../config/environment';

// Configuration - Set to false for production
export const USE_MOCK_DATA = false;

// Mock User Data
export const mockUsers = [
  {
    id: 1,
    username: 'admin',
    email: 'admin@hospital.com',
    first_name: 'SuperUser',
    last_name: 'Administrator',
    role: 'superuser',
    department_id: 1,
    department_name: 'Child Health',
    unit_id: 1,
    unit_name: 'PER',
    is_active: true,
    created_at: '2024-01-01T00:00:00Z'
  },
  {
    id: 2,
    username: 'dr.smith',
    email: 'dr.smith@hospital.com',
    first_name: 'Dr. Sarah',
    last_name: 'Smith',
    role: 'reviewer',
    department_id: 2,
    department_name: 'Cardiology',
    unit_id: 2,
    unit_name: 'Cardiac ICU',
    is_active: true,
    created_at: '2024-01-15T00:00:00Z'
  },
  {
    id: 3,
    username: 'dr.johnson',
    email: 'dr.johnson@hospital.com',
    first_name: 'Dr. Michael',
    last_name: 'Johnson',
    role: 'reviewer',
    department_id: 3,
    department_name: 'Pulmonology',
    unit_id: 3,
    unit_name: 'Respiratory ICU',
    is_active: true,
    created_at: '2024-01-20T00:00:00Z'
  },
  {
    id: 4,
    username: 'nurse.wilson',
    email: 'nurse.wilson@hospital.com',
    first_name: 'Emily',
    last_name: 'Wilson',
    role: 'auditor',
    department_id: 2,
    department_name: 'Cardiology',
    unit_id: 2,
    unit_name: 'Cardiac ICU',
    is_active: true,
    created_at: '2024-02-01T00:00:00Z'
  },
  {
    id: 5,
    username: 'nurse.brown',
    email: 'nurse.brown@hospital.com',
    first_name: 'James',
    last_name: 'Brown',
    role: 'auditor',
    department_id: 3,
    department_name: 'Pulmonology',
    unit_id: 3,
    unit_name: 'Respiratory ICU',
    is_active: true,
    created_at: '2024-02-05T00:00:00Z'
  },
  {
    id: 6,
    username: 'dr.davis',
    email: 'dr.davis@hospital.com',
    first_name: 'Dr. Jennifer',
    last_name: 'Davis',
    role: 'reviewer',
    department_id: 4,
    department_name: 'Neurology',
    unit_id: 4,
    unit_name: 'Neuro ICU',
    is_active: true,
    created_at: '2024-02-10T00:00:00Z'
  }
];

// Mock Patient Data (EMR Format)
export const mockPatients = [
  {
    id: 1,
    patient_id: '15479782',
    note_no: '26382',
    note_date: '2025-08-06T20:29:09Z',
    visit_id: '7630842',
    trf_id: '7462408',
    time_of_death: '2025-09-02',
    place_of_death: '148',
    place_description: 'natural',
    cause_of_death: '2 months old child ,trisomy 13 ,DNR, he vomitted after feed then became unresponsive , on arrival unresponsive , no cardiac activity, not breathing',
    created_by: '80828',
    created_time: '2025-09-02',
    modified_by: null,
    modified_time: null,
    cause_death_direct: 'trisomy 13, DNR patient',
    cause_death_underlying1: 'aspirated post feeding',
    cause_death_underlying2: null,
    cause_death_underlying3: null,
    interval_direct: null,
    interval_underlying1: null,
    interval_underlying2: null,
    interval_underlying3: null,
    interval_other: null,
    manner_of_death: '10378',
    injury_type: '10389',
    dept: '55',
    unit_id: '66',
    visit_time: '2025-08-06T20:29:09Z',
    trf_date: '2025-08-06T21:29:09Z',
    prov_diagnosis: 'Acute chest syndrome',
    final_diagnosis: 'Acute Chest syndrome',
    audit_status: 'assigned',
    is_audit_required: true,
    age: 2,
    gender: 'Male'
  },
  {
    id: 2,
    patient_id: '15479783',
    note_no: '26383',
    note_date: '2025-08-07T15:30:00Z',
    visit_id: '7630843',
    trf_id: '7462409',
    time_of_death: '2025-09-03',
    place_of_death: '149',
    place_description: 'hospital',
    cause_of_death: 'Elderly patient with multiple comorbidities, cardiac arrest during surgery',
    created_by: '80829',
    created_time: '2025-09-03',
    modified_by: null,
    modified_time: null,
    cause_death_direct: 'Cardiac arrest',
    cause_death_underlying1: 'Post-operative complications',
    cause_death_underlying2: 'Diabetes mellitus',
    cause_death_underlying3: 'Hypertension',
    interval_direct: 'immediate',
    interval_underlying1: '2 hours',
    interval_underlying2: '5 years',
    interval_underlying3: '10 years',
    interval_other: null,
    manner_of_death: '10379',
    injury_type: '10390',
    dept: '56',
    unit_id: '67',
    visit_time: '2025-08-07T15:30:00Z',
    trf_date: '2025-08-07T16:30:00Z',
    prov_diagnosis: 'Post-operative complications',
    final_diagnosis: 'Post-operative cardiac arrest',
    audit_status: 'in_progress',
    is_audit_required: true,
    age: 72,
    gender: 'Female',
  },
  {
    id: 3,
    patient_id: '15479784',
    note_no: '26384',
    note_date: '2025-08-08T09:15:00Z',
    visit_id: '7630844',
    trf_id: '7462410',
    time_of_death: '2025-09-04',
    place_of_death: '150',
    place_description: 'home',
    cause_of_death: 'Stroke patient, found unresponsive at home, brought to hospital',
    created_by: '80830',
    created_time: '2025-09-04',
    modified_by: null,
    modified_time: null,
    cause_death_direct: 'Cerebrovascular accident',
    cause_death_underlying1: 'Hypertension',
    cause_death_underlying2: 'Atrial fibrillation',
    cause_death_underlying3: null,
    interval_direct: '6 hours',
    interval_underlying1: '15 years',
    interval_underlying2: '3 years',
    interval_underlying3: null,
    interval_other: null,
    manner_of_death: '10380',
    injury_type: '10391',
    dept: '57',
    unit_id: '68',
    visit_time: '2025-08-08T09:15:00Z',
    trf_date: '2025-08-08T10:15:00Z',
    prov_diagnosis: 'Acute stroke',
    final_diagnosis: 'Acute ischemic stroke',
    audit_status: 'submitted',
    is_audit_required: true,
    age: 58,
    gender: 'Male',
  },
  {
    id: 4,
    note_no: 'N2024004',
    patient_id: 'P001234570',
    time_of_death: '2024-03-18T07:15:00Z',
    cause_of_death: 'Sepsis',
    dept: 'Internal Medicine',
    unit_id: 'Medical ICU',
    final_diagnosis: 'Septic shock with multi-organ failure',
    audit_status: 'approved',
    is_audit_required: true,
    age: 81,
    gender: 'Female',
  },
  {
    id: 5,
    note_no: 'N2024005',
    patient_id: 'P001234571',
    time_of_death: '2024-03-19T13:45:00Z',
    cause_of_death: 'Post-operative Complications',
    dept: 'Surgery',
    unit_id: 'Surgical ICU',
    final_diagnosis: 'Post-operative bleeding with DIC',
    audit_status: 'overdue',
    is_audit_required: true,
    age: 45,
    gender: 'Male',
  }
];

// Mock Audit Assignments
export const mockAuditAssignments = [
  {
    id: 1,
    case_type: 'mortality',
    case_id: 1,
    assignment_type: 'individual',
    multi_auditor_support: false,
    assigned_to_id: 4,
    assigned_to_name: 'Emily Wilson',
    assigned_to_role: 'auditor',
    primary_auditor_id: 4,
    supervisor_id: 2,
    reviewer_name: 'Dr. Sarah Johnson',
    reviewer_role: 'reviewer',
    assigned_by: 1,
    assigned_by_name: 'Admin User',
    assigned_date: '2024-03-16T08:00:00Z',
    due_date: '2024-03-23T17:00:00Z',
    status: 'assigned',
    priority: 'high',
    notes: 'Recent MI case requiring thorough review',
    progress_percentage: 0,
    patient_id: 'P001234567',
    age: 65,
    gender: 'Male',
    cause_of_death: 'Myocardial infarction with complications',
    case_summary: null,
    all_auditor_names: 'Emily Wilson (Primary)',
    auditor_count: 1,
    has_form_record: false
  },
  {
    id: 2,
    case_type: 'morbidity',
    case_id: 2,
    assignment_type: 'team',
    multi_auditor_support: false,
    assigned_to_id: 1,
    assigned_to_name: 'Cardiology Audit Team',
    assigned_to_role: 'team',
    primary_auditor_id: 5,
    supervisor_id: 2,
    reviewer_name: 'Dr. Michael Chen',
    reviewer_role: 'reviewer',
    assigned_by: 1,
    assigned_by_name: 'Admin User',
    assigned_date: '2024-03-17T09:00:00Z',
    due_date: '2024-03-24T17:00:00Z',
    status: 'in_progress',
    priority: 'medium',
    notes: 'ARDS case - focus on respiratory management',
    progress_percentage: 45,
    patient_id: 'P001234568',
    age: 45,
    gender: 'Female',
    cause_of_death: null,
    case_summary: 'Acute respiratory distress syndrome following pneumonia',
    all_auditor_names: 'James Brown (Primary)',
    auditor_count: 1,
    has_form_record: true
  },
  {
    id: 3,
    case_type: 'mortality',
    case_id: 3,
    assignment_type: 'multi_individual',
    multi_auditor_support: true,
    assigned_to_id: 4,
    assigned_to_name: 'Emily Wilson',
    assigned_to_role: 'auditor',
    primary_auditor_id: 4,
    supervisor_id: 2,
    reviewer_name: 'Dr. Sarah Johnson',
    reviewer_role: 'reviewer',
    assigned_by: 1,
    assigned_by_name: 'Admin User',
    assigned_date: '2024-03-18T10:00:00Z',
    due_date: '2024-03-25T17:00:00Z',
    status: 'submitted',
    priority: 'high',
    notes: 'Stroke case - neurological assessment complete',
    progress_percentage: 100,
    patient_id: 'P001234569',
    age: 72,
    gender: 'Male',
    cause_of_death: 'Cerebrovascular accident with complications',
    case_summary: null,
    all_auditor_names: 'Emily Wilson (Primary), Dr. John Smith (Secondary)',
    auditor_count: 2,
    has_form_record: true
  },
  {
    id: 4,
    case_type: 'morbidity',
    case_id: 4,
    assignment_type: 'individual',
    multi_auditor_support: false,
    assigned_to_id: 1,
    assigned_to_name: 'System Administrator',
    assigned_to_role: 'superuser',
    primary_auditor_id: 1,
    supervisor_id: 2,
    reviewer_name: 'Dr. Michael Chen',
    reviewer_role: 'reviewer',
    assigned_by: 1,
    assigned_by_name: 'Admin User',
    assigned_date: '2024-03-15T14:00:00Z',
    due_date: '2024-03-22T17:00:00Z',
    status: 'approved',
    priority: 'low',
    notes: 'Post-operative complication case',
    progress_percentage: 100,
    patient_id: 'P001234570',
    age: 38,
    gender: 'Female',
    cause_of_death: null,
    case_summary: 'Post-operative wound infection requiring additional treatment',
    all_auditor_names: 'System Administrator (Primary)',
    auditor_count: 1,
    has_form_record: true
  },
  {
    id: 5,
    case_type: 'mortality',
    case_id: 5,
    assignment_type: 'individual',
    multi_auditor_support: false,
    assigned_to_id: 1,
    assigned_to_name: 'System Administrator',
    assigned_to_role: 'superuser',
    primary_auditor_id: 1,
    supervisor_id: 2,
    reviewer_name: 'Dr. Sarah Johnson',
    reviewer_role: 'reviewer',
    assigned_by: 1,
    assigned_by_name: 'Admin User',
    assigned_date: '2024-03-20T11:00:00Z',
    due_date: '2024-03-27T17:00:00Z',
    status: 'rejected',
    priority: 'urgent',
    notes: 'Cardiac arrest case - needs revision',
    progress_percentage: 75,
    patient_id: 'P001234571',
    age: 58,
    gender: 'Male',
    cause_of_death: 'Cardiac arrest with unsuccessful resuscitation',
    case_summary: null,
    all_auditor_names: 'System Administrator (Primary)',
    auditor_count: 1,
    has_form_record: false
  }
];

// Mock Dashboard Stats
export const mockDashboardStats = {
  totalAudits: 47,
  pendingAudits: 12,
  completedAudits: 28,
  overdueAudits: 7,
  teamMembers: 15,
  monthlyTrend: 12.5
};

// Mock Recent Audits
export const mockRecentAudits = [
  {
    id: 1,
    patient_id: 'P001234567',
    patient_name: 'John Doe',
    status: 'assigned',
    assigned_date: '2024-03-16T08:00:00Z',
    due_date: '2024-03-23T17:00:00Z',
    auditor_name: 'Emily Wilson'
  },
  {
    id: 2,
    patient_id: 'P001234568',
    patient_name: 'Jane Smith',
    status: 'in_progress',
    assigned_date: '2024-03-17T09:00:00Z',
    due_date: '2024-03-24T17:00:00Z',
    auditor_name: 'James Brown'
  },
  {
    id: 3,
    patient_id: 'P001234569',
    patient_name: 'Robert Johnson',
    status: 'submitted',
    assigned_date: '2024-03-18T10:00:00Z',
    due_date: '2024-03-25T17:00:00Z',
    auditor_name: 'Emily Wilson'
  },
  {
    id: 4,
    patient_id: 'P001234570',
    patient_name: 'Mary Davis',
    status: 'approved',
    assigned_date: '2024-03-10T14:00:00Z',
    due_date: '2024-03-17T17:00:00Z',
    auditor_name: 'Dr. Sarah Smith'
  },
  {
    id: 5,
    patient_id: 'P001234571',
    patient_name: 'David Wilson',
    status: 'overdue',
    assigned_date: '2024-03-15T11:00:00Z',
    due_date: '2024-03-22T17:00:00Z',
    auditor_name: 'Dr. Michael Johnson'
  }
];

// Mock Notifications
export const mockNotifications = [
  {
    id: 1,
    user_id: 1,
    type: 'info',
    title: 'New Audit Assigned',
    message: 'You have been assigned a new mortality audit for patient P001234567.',
    read_status: false,
    action_url: '/audit/1',
    action_text: 'View Audit',
    created_at: '2024-03-20T10:30:00Z'
  },
  {
    id: 2,
    user_id: 1,
    type: 'warning',
    title: 'Audit Overdue',
    message: 'Audit for patient P001234571 is overdue and requires immediate attention.',
    read_status: false,
    action_url: '/audit/5',
    action_text: 'View Audit',
    created_at: '2024-03-19T15:45:00Z'
  },
  {
    id: 3,
    user_id: 1,
    type: 'success',
    title: 'Audit Approved',
    message: 'Your audit for patient P001234570 has been approved by the reviewer.',
    read_status: true,
    action_url: '/audit/4',
    action_text: 'View Audit',
    created_at: '2024-03-18T14:20:00Z'
  }
];

// Mock Audit Logs
export const mockAuditLogs = [
  {
    id: 1,
    userId: 1,
    userName: 'System Administrator',
    action: 'login',
    entityType: 'user',
    entityId: '1',
    details: { ip_address: '192.168.1.100', user_agent: 'Mozilla/5.0...' },
    timestamp: new Date('2024-03-20T09:00:00Z'),
    ipAddress: '192.168.1.100',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36'
  },
  {
    id: 2,
    userId: 4,
    userName: 'Emily Wilson',
    action: 'audit_assigned',
    entityType: 'audit',
    entityId: '1',
    details: { patient_id: 'P001234567', due_date: '2024-03-23T17:00:00Z' },
    timestamp: new Date('2024-03-20T10:30:00Z'),
    ipAddress: '192.168.1.105',
    userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36'
  },
  {
    id: 3,
    userId: 2,
    userName: 'Dr. Sarah Smith',
    action: 'audit_approved',
    entityType: 'audit',
    entityId: '4',
    details: { patient_id: 'P001234570', reviewer_notes: 'Comprehensive review completed' },
    timestamp: new Date('2024-03-20T14:20:00Z'),
    ipAddress: '192.168.1.110',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36'
  }
];

// Mock Departments
export const mockDepartments = [
  { id: 1, name: 'Administration', description: 'Hospital Administration', emr_code: 1001, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 2, name: 'Cardiology', description: 'Heart and Cardiovascular Care', emr_code: 1002, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 3, name: 'Pulmonology', description: 'Respiratory and Lung Care', emr_code: 1003, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 4, name: 'Neurology', description: 'Brain and Nervous System Care', emr_code: 1004, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 5, name: 'Surgery', description: 'Surgical Services', emr_code: 1005, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 6, name: 'Internal Medicine', description: 'General Internal Medicine', emr_code: 1006, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 7, name: 'Emergency', description: 'Emergency Department', emr_code: 1007, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 8, name: 'Pediatrics', description: 'Pediatric Care', emr_code: 1008, is_active: 1, created_at: '2024-01-01T00:00:00Z' }
];

// Mock Units
export const mockUnits = [
  { id: 1, name: 'IT Department', department_id: 1, description: 'Information Technology Department', emr_code: 2001, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 2, name: 'Cardiac ICU', department_id: 2, description: 'Intensive care for cardiac patients', emr_code: 2002, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 3, name: 'Cardiac Ward', department_id: 2, description: 'General cardiac care ward', emr_code: 2003, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 4, name: 'Respiratory ICU', department_id: 3, description: 'Intensive care for respiratory patients', emr_code: 2004, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 5, name: 'Neuro ICU', department_id: 4, description: 'Intensive care for neurological patients', emr_code: 2005, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 6, name: 'Surgical ICU', department_id: 5, description: 'Intensive care for surgical patients', emr_code: 2006, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 7, name: 'Operating Room', department_id: 5, description: 'Main operating theater', emr_code: 2007, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 8, name: 'Medical ICU', department_id: 6, description: 'Medical intensive care unit', emr_code: 2008, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 9, name: 'Emergency Room', department_id: 7, description: 'Emergency department', emr_code: 2009, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 10, name: 'Trauma Unit', department_id: 7, description: 'Trauma and critical care', emr_code: 2010, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 11, name: 'Pediatric Ward', department_id: 8, description: 'General pediatric care', emr_code: 2011, is_active: 1, created_at: '2024-01-01T00:00:00Z' },
  { id: 12, name: 'NICU', department_id: 8, description: 'Neonatal intensive care unit', emr_code: 2012, is_active: 1, created_at: '2024-01-01T00:00:00Z' }
];

// Utility function to simulate API delay
export const simulateApiDelay = (ms: number = 500): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

// Mock API Response Helper
export const createMockResponse = <T>(data: T): { success: true; data: T; message: string; timestamp: string } => ({
  success: true,
  data,
  message: 'Success',
  timestamp: new Date().toISOString()
});

// Mock Error Response
export const createMockError = (message: string = 'An error occurred'): { success: false; message: string; timestamp: string } => ({
  success: false,
  message,
  timestamp: new Date().toISOString()
});

// Development Helper - Log when mock data is being used
if (USE_MOCK_DATA) {
  console.log('🔧 Mock Data Service: ENABLED - Using mock data for development');
  console.log('📊 Available mock data:', {
    users: mockUsers.length,
    patients: mockPatients.length,
    auditAssignments: mockAuditAssignments.length,
    notifications: mockNotifications.length,
    auditLogs: mockAuditLogs.length
  });
} else {
  console.log('🚀 Mock Data Service: DISABLED - Using real API data');
}
